var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import { UrlHelper } from '../../../helper/UrlWrapper';
import WarningRuleService from '../../../api/WarningRuleService';
import { Loading } from 'element-ui';
import ListHeader from './ListHeader.vue';
var TYPE_API = {
    1: {
        name: '有效期预警',
        api: 'stock_validity_warning',
    },
    2: {
        name: '大库存预警',
        api: 'stock_exceed_warning',
    },
    3: {
        name: '滞销预警',
        api: 'stock_unsalable_warning',
    },
    4: {
        name: '安全库存预警',
        api: 'stock_safe_warning',
    },
};
var WarnList = (function (_super) {
    __extends(WarnList, _super);
    function WarnList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        return _this;
    }
    WarnList.prototype.created = function () {
        this.service = WarningRuleService.getInstance();
    };
    WarnList.prototype.toDetail = function (row) {
        this.$emit('toDetail', row.warning_id, row.organ_id, row.depot_id);
    };
    WarnList.prototype.resetAll = function () {
        this.$refs.ListHeader.reset();
        this.filter = null;
        this.listData = [];
        this.$refs.Table.clearSelection();
        this.$refs.Table.clearSort();
    };
    WarnList.prototype.exportData = function () {
        if (!this.checkSelectIds())
            return;
        var warning_ids = this.getSelectIds();
        var url = "supplierclientapi/" + TYPE_API[this.type].api + "/export?warning_ids=" + warning_ids;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', TYPE_API[this.type].name, TYPE_API[this.type].name + "\u5BFC\u51FA"]);
    };
    WarnList.prototype.getSelectIds = function () {
        var warningIds = this.selectRows.map(function (item) { return item.warning_id; });
        return warningIds.join(',');
    };
    WarnList.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    WarnList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    WarnList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    WarnList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getWarningList(Object.assign({
            sort_field: this.order ? this.order[0] : null,
            sort_type: this.order ? this.order[1] : null,
        }, this.filter, pager), TYPE_API[this.type].api)
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data;
            _this.listData = DATA.data;
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    WarnList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    WarnList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    __decorate([
        Prop({
            required: true,
        })
    ], WarnList.prototype, "type", void 0);
    WarnList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            components: {
                'list-header': ListHeader,
            },
        })
    ], WarnList);
    return WarnList;
}(Vue));
export default WarnList;
